module.exports = __webpack_public_path__ + "static/img/avatar-small.e3c44b70.png";